/**
 * Certification detail.
 */

// Module styles
import './_certification-detail.scss';
